import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchPeriods = createAsyncThunk('fetchPeriods', async (_, { getState, rejectWithValue }) => {
  const url = '/periods';

  try {
    const { data, status } = await api.get(url);
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch periods'));
  }
});

export const periodSlice = createSlice({
  name: 'periods',
  initialState: {
    periods: null,
    activePeriod: null,
    shouldPollForPeriods: false,
  },
  reducers: {
    addPeriod: (state, action) => {
      // add to the first position
      state.periods = [action.payload, ...state.periods];
    },
    pollPeriods: (state, action) => {
      state.shouldPollForPeriods = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPeriods.fulfilled, (state, action) => {
        state.periods = action.payload.data.periods;
        state.activePeriod = action.payload.data.active_period;
        state.shouldPollForPeriods = action.payload.data.periods.every(period => !period.ready);

        Sentry.setContext('period', {
          name: action.payload.data.active_period
        })
      });

  }
});

export const getPeriods = (state) => state.periods.periods;
export const getActivePeriod = (state) => state.periods.activePeriod;
export const getShouldPollForPeriods = (state) => state.periods.shouldPollForPeriods;

export { fetchPeriods };

export const { addPeriod, pollPeriods } = periodSlice.actions;

export default periodSlice.reducer;
